export const environments = {
  apiGateway: process.env.NEXT_PUBLIC_API_GATEWAY,
  restApiUrl: `${process.env.NEXT_PUBLIC_API_GATEWAY}/api/v1`,
  socketConnection: `${process.env.NEXT_PUBLIC_API_GATEWAY}`,
  restApiUrlv2: `${process.env.NEXT_PUBLIC_API_GATEWAY}/api/v2`,
  cmsApiUrl: `${process.env.NEXT_PUBLIC_API_CMS}/v2`,
  graphApiUrl: `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
  googleMapAPIKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY,
  googleMapID: process.env.NEXT_PUBLIC_GOOGLE_MAP_ID,
  appMode: process.env.NEXT_PUBLIC_APP_MODE,
  siteURL: process.env.NEXT_PUBLIC_API_GATEWAY,
  businessApiUrl: process.env.NEXT_PUBLIC_BUSINESS_API_URL,
  businessApiKey: process.env.NEXT_PUBLIC_BUSINESS_API_KEY,
  aiChatUrl: process.env.NEXT_PUBLIC_AI_CHAT_URL,
  authServerUrl: process.env.NEXT_PUBLIC_AUTH_SERVER,
  mediaGroupDetailInfo: `${process.env.NEXT_PUBLIC_API_MEDIA_INFO}/api/v1`,
};
